import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import GlobalActionMenu from '../GlobalActionMenu/GlobalActionMenu'

class PlaylistHeader extends React.Component {
  static propTypes = {
    t: PropTypes.func,
    isIpadView: PropTypes.bool
  }

  render() {
    return (
      <div className="flex-none pt-6 xl:pt-7.5 px-6 xl:px-12 flex justify-between items-center relative">
        <div className="flex items-center">
          <p className="mr-6 xl:text-xl inline align-middle uppercase text-white font-header tracking-sectionTitle">
            playlists
          </p>
        </div>
        <GlobalActionMenu />
      </div>
    )
  }
}

const mapStateToProps = ({ global }) => ({
  isIpadView: global.isIpadView
})

export default withTranslation()(connect(mapStateToProps)(PlaylistHeader))
